import React from 'react';
import intl from 'react-intl-universal';
import DetailTitle from "@/components/DetailTitle"
import styles from './index.module.scss'
import MdPreview from '@/components/MdEditor';
const Description = ({ title, des }) => {
	const content = des == null ? '' : String(des).trim();
	const displayContent = !content || /^(null|undefined)$/i.test(content) ? intl.get('Discover.Not available') : content;
	// const lines = des.split('\n');
	return (
		<div>
			<DetailTitle title={title} />
			<MdPreview height={"auto"} plugins={[]} textContent={displayContent} />
			{/* {lines.map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    {index < lines.length - 1 && <br />}
                </React.Fragment>
            ))} */}
			{/* <div className={styles.desBox}>{des}</div> */}
		</div>
	)
}
export default Description;
